import { commonFirstNames } from '@/containers/ContactLists/names';
import { ColumnData } from '../types';

const _nameSet = new Set(commonFirstNames.map((n) => n.toLowerCase()));

export const getColumnsFromData = (data: string[][]) => {
  const [headers] = data;
  const result: string[][] = [];

  headers.forEach((_, cIdx) => {
    const column = [];
    for (let rowIdx = 0; rowIdx < data.length; rowIdx++) {
      column.push(data[rowIdx][cIdx]);
    }
    result.push(column);
  });

  return result;
};

export const getSuggestedPhoneNumberColumn = (columnData: ColumnData[]) => {
  const targetColumn = columnData.find((c) => {
    // Look for at least 1 match in every column with exactly 10 digits
    return c.data.find((item) => {
      const cleanedItem = (item ?? '').replace(/-/g, '').replace(/(^1|^\+1)/g, '');
      return /^\d{10}$/.test(cleanedItem); // Checks if the cleanedItem contains exactly 10 digits
    });
  });
  return targetColumn;
};

export const getSuggestedFirstNameColumn = (
  columnData: ColumnData[]
): ColumnData | undefined => {
  let targetColumn: ColumnData | undefined;
  let maxCount = 0;

  columnData.forEach((c) => {
    const count = c.data.reduce((acc, dataName) => {
      const lowerName = dataName.split(' ')[0]?.toLowerCase();
      return _nameSet.has(lowerName) ? acc + 1 : acc;
    }, 0);

    if (count > maxCount) {
      maxCount = count;
      targetColumn = c;
    }
  });

  return targetColumn;
};
